<template>
    <div class="px-8">
        <form-header title="Distribution"/>

        <form-input v-if="localCopy.Device" id="reg-model" label="Model" :modelValue="localCopy.Device.DeviceModel.name" readonly="true"/>
        <form-input v-if="localCopy.Device" id="reg-serial" label="Serial" :modelValue="localCopy.Device.serial" readonly="true"/>


        <form-input id="reg-data" label="Date of Registration" :modelValue="momentDate(localCopy.date)" readonly="true"/>

        <form-toggle v-if="localCopy.Device" label="Warranty Registered" :modelValue="localCopy.Device.warrantyRegistered" />
        <form-input v-if="localCopy.Device && localCopy.Device.warrantyRegistered" label="Warranty Valid To" :modelValue="momentDate(localCopy.Device.warrantyExpiryDate)" readonly="true"/>

        <form-input id="reg-custref" label="Customer Reference" :error="msg.job_ref" v-model.trim="localCopy.job_ref" :readonly="true"/>
        <form-input id="reg-notes" label="Notes" :error="msg.notes" v-model.trim="localCopy.notes" :readonly="true"/>

        <div v-if="localCopy.Installer">
            <form-header title="Installer" class="pt-4"/>
            <form-input id="reg-inst" label="Installer" :modelValue="installerName" :readonly="true"/>
            <form-input id="reg-inst-co" label="Installer Company" :modelValue="localCopy.Installer.company" :readonly="true"/>
            <form-input id="reg-inst-tel" label="Installer Mobile" :modelValue="localCopy.Installer.tel" :readonly="true"/>
            <form-input id="reg-inst-email" label="Installer Email" :modelValue="localCopy.Installer.email" :readonly="true"/>
        </div>

        <form-div v-if="localCopy.address" label="Installation Address">
            <textarea readonly class="h-24 bg-gray-100 block w-full rounded-md border-gray-300 shadow-sm focus:border-gray-300 focus:ring-gray-300 text-sm text-gray-700" :value="localCopy.address">
            </textarea>
        </form-div>
        <div v-if="localCopy.installPhotos" class="pt-2">
            <form-div v-if="!localCopy.installPhotos.length" label="Photographs"><span class="text-gray-400">No photos supplied</span></form-div>
            <form-image v-if="localCopy.installPhotos.length" id="dev-iamge" label="Photographs" :images="localCopy.installPhotos"/>
        </div>

        <form-header title="Registration" class="pt-8"/>

        <div v-if="!localCopy.distributorApproved">
            <form-input id="reg-installed-company" label="Customer (As Entered by Installer)" :error="msg.customer" v-model.trim="localCopy.customer" :readonly="true"/>

            <form-select id="reg-select-company" label="Register to" :options="companies" v-model="selectedCompany"/>
                <form-input id="reg-installed-company" label="Company Name" labelClass="pl-4" v-if="selectedCompany == -1" :error="msg.customerName" v-model.trim="customerName"/>
                <form-input id="reg-installed-email" label="Email" labelClass="pl-4" v-if="selectedCompany == -1" :error="msg.email" v-model.trim="customerEmail"/>
                <form-input id="reg-installed-fgas" label="FGAS" labelClass="pl-4" v-if="selectedCompany == -1" :error="msg.email" v-model.trim="customerFgas"/>
            <form-select id="reg-assign-points" label="Assign Points to" :options="assignCompanies" v-model="selectedPointsCompany"/>

            <form-header class="pt-2 flex flex-col gap-2">
                <custom-button type="primary" @click="assignToCompany" class="w-64">Register and Assign Points</custom-button>
            </form-header>
        </div>
        
        <div v-if="localCopy.distributorApproved">
            <form-input v-if="localCopy.Customer" id="reg-installed-company" label="Company Name" v-model="localCopy.Customer.name" :readonly="true"/>
            <form-input v-if="localCopy.PointsCompany" id="points-company" label="Points Assigned To" v-model="localCopy.PointsCompany.name" :readonly="true"/>

            <form-div >
                <div v-if="!localCopy.certificate">Certificate has not been generated</div>
                <custom-button v-if="localCopy.certificate" class="w-full" type="white" @click="onDownloadCertButton">
                        <DownloadIcon class="h-6 w-6 text-gray-800"/>
                        Download Certificate
                </custom-button>

            </form-div>

        </div>

        <h4 class="text-sm font-medium pt-6">Service History</h4>
        <form-table v-if="localCopy && localCopy.history" :data="serviceHistoryTable" class="pt-4"/>

    </div>
</template>

<script>
import FormHeader from '../components/FormHeader.vue'
import FormImage from '../components/FormImage.vue'
import FormInput from '../components/FormInput.vue'
import FormTable from '../components/FormTable.vue'
import FormDiv from '../components/FormDiv.vue'
import FormToggle from '../components/FormToggle.vue'
import FormSelect from '../components/FormSelect.vue'
import CustomButton from '../components/CustomButton.vue'
import {closestMatch} from 'closest-match'
import {mapGetters} from 'vuex'
import DownloadFile from '../DownloadFile.js'
import { DownloadIcon } from '@heroicons/vue/solid';

export default {
    components: { FormHeader, FormInput, FormImage, FormDiv, CustomButton, FormSelect, FormTable, FormToggle, DownloadIcon },
    data: function() {
        return {
            changed: false,
            data: {},
            localCopy: { DeviceModel: {} },
            msg: {},
            companies: [],
            assignCompanies: [],
            selectedCompany: 0,
            selectedPointsCompany: -1,
            customerName: '',
            customerFgas: '',
            customerEmail: '',
        }
    },
    computed: {
        ...mapGetters(['user']),
        installerName: function() {
            if (!this.localCopy.Installer) {
                return ''
            }
            return this.localCopy.Installer.firstName + ' ' + this.localCopy.Installer.lastName
        },
        serviceHistoryTable: function() {
            let table = {}
            table.rows = []
            for (let svc of this.localCopy.history) {
                table.rows.push({
                    date: this.momentDate(svc.date),
                    type: svc.type
                })
            }
            table.keys = [
                { title: 'Date', key:'date' },
                { title: 'Type', key:'type' },
            ]
            return table
        },
    },
    props: [
        'id',
        'prev'
    ],
    mounted: async function() {
        let query
        try {
            query = await this.axios.get(`/co/distribution/${this.id}`)
            this.data = query.data

            query = await this.axios.get('/co/distribution/autocomplete')
            const companies = query.data

            this.assignCompanies = [ { id: -1, name: 'Same as registered company'},
                                    //  { id: -2, name: 'Keep points' },
                                      ]

            this.companies = [ { id: -1, name: 'Create New Company'},
                                 ...companies ]

            this.selectedCompany = this.findClosestCompany(this.data.customer.toLowerCase())
            this.assignToCompany = this.selectedCompany
        }
        catch {
            this.$router.push('/')
            return
        }
        this.customerName = this.data.customer
        this.localCopy = Object.assign(Object.create(Object.getPrototypeOf(this.data)), this.data)

    },
    methods: {
        findClosestCompany: function(companyName) {
            companyName = companyName.toLowerCase()
            if (this.companies.length > 0) {
                const companyNames = this.companies.map(a => a.name.toLowerCase())
                const closestCompanyName = closestMatch(companyName, companyNames)
                return this.companies.find(a => a.name.toLowerCase() == closestCompanyName).id
            }
            return 0
        },
        assignToCompany: async function() {
            let assignPointsCompany = (this.selectedPointsCompany == -2) ? this.user.id : this.selectedPointsCompany
            if (this.selectedCompany != -1 && this.selectedPointsCompany == -1) {
                assignPointsCompany = this.selectedCompany
            }
            
            let notes = (this.selectedCompany == -1) ? `Email: ${this.customerEmail} FGAS: ${this.customerFgas}` : ''
            await this.axios.post(`/co/distribution/assign/${this.id}`, {
                company: this.customerName,
                companyId: this.selectedCompany,
                pointsCompanyId: assignPointsCompany,
                notes: notes
            })
            this.$router.push('/co/distribution/awaitingapproval')
        },
        async onDownloadCertButton() {
           let query = await this.axios.get(`/distCertLinkFromReg/${this.localCopy.id}`)
           DownloadFile(document, 'certificate.pdf', query.data)
        },        
    }
}
</script>